import React, { JSX } from 'react';
import {
    Card, CardBody, CardFooter, CardHeader, Divider, Heading,
} from '@chakra-ui/react';

import { StandardUnauthorisedPageProps } from './StandardUnauthorisedPage.types';
import Styled from './StandardUnauthorisedPage.styled';

function StandardUnauthorisedPage({
    children,
    pageTitle,
    footerContent,
    width = ['90%', '90%', '500px'],
}: StandardUnauthorisedPageProps): JSX.Element {
    return (
        <Styled.StandardAuthorisedPageContentWrapper width={width}>
            <Card>
                {pageTitle && (
                    <>
                        <CardHeader>
                            <Heading size="md">{pageTitle}</Heading>
                        </CardHeader>
                        <Divider />
                    </>
                )}

                <CardBody>
                    {children}
                </CardBody>

                {footerContent
                    ? (
                        <>
                            <Divider />

                            <CardFooter>
                                {footerContent}
                            </CardFooter>
                        </>
                    ) : <></>}
            </Card>
        </Styled.StandardAuthorisedPageContentWrapper>

    );
}

export default StandardUnauthorisedPage;
